import React from 'react';
import PropTypes from 'prop-types';
import { CombinedSelect } from '@ynap/select';
import { withRouter } from 'react-router';
import BEMHelper from '@ynap/bem-helper';
import Skeleton from '@ynap/skeleton';
import track, { TrackingPropType } from 'react-tracking';
import { withAnalytics, safeBuildEventObj } from '@ynap/analytics';
import { performance } from '@ynap/clientside-monitoring';
import { trackSort } from '../analytics';
import { withOptimizely } from '@ynap/optimizely-utils';

const bem = new BEMHelper('OrderBy');

const getOrderByValue = (sortOptions) => {
    const selectedOrderBy = (sortOptions && sortOptions.find((o) => o.selected)) || { value: '' };
    return selectedOrderBy.value;
};

const getSelectedOrderByLabel = (sortOptions, selectedValue) => {
    const label = sortOptions.find((o) => o.key === selectedValue).label || '';
    return label.replace(/\s+/g, '').toLowerCase();
};

const updateUrlAndRedirect = (location, value, history, sortOptions, analytics, tracking, optimizely) => {
    optimizely?.track('global_sortBy');
    optimizely?.track(`sortby_${getSelectedOrderByLabel(sortOptions, value)}`);
    performance.intTiming.markSpaInteractionTime('sort');
    tracking.trackEvent(safeBuildEventObj(trackSort, analytics, value, sortOptions));
    history.push(location);
};

const OrderBy = (props) => {
    const { sortOptions, generateListingUrl, history, messages, className, alternateBorder, loading, analytics, tracking, optimizely } = props;

    return loading ? (
        <div className={bem(null, null, className)}>
            <div className={bem('skeleton')}>
                <Skeleton />
            </div>
        </div>
    ) : (
        <div className={bem(null, null, className)}>
            <CombinedSelect
                type="link"
                value={getOrderByValue(sortOptions)}
                className={bem('select')}
                alternateBorder={alternateBorder}
                onChange={(value) => {
                    updateUrlAndRedirect(
                        generateListingUrl({
                            replaceParams: { orderBy: value, pageNumber: 1 },
                        }),
                        value,
                        history,
                        sortOptions,
                        analytics,
                        tracking,
                        optimizely,
                    );
                }}
                options={sortOptions}
                numOfListElementsDisplayed={sortOptions ? sortOptions.length : 0}
                emptyLabel={messages.productListing.sortBy()}
                tracking={tracking}
            />
        </div>
    );
};

OrderBy.propTypes = {
    history: PropTypes.object.isRequired,
    sortOptions: PropTypes.array.isRequired,
    generateListingUrl: PropTypes.func.isRequired,
    messages: PropTypes.shape({
        productListing: PropTypes.shape({
            sortBy: PropTypes.func.isRequired,
        }).isRequired,
    }),
    loading: PropTypes.bool,
    className: PropTypes.string,
    alternateBorder: PropTypes.bool,
    tracking: TrackingPropType,
    optimizely: PropTypes.shape({
        track: PropTypes.func,
    }),
};

export const routedOrderBy = withRouter(OrderBy);

export default track()(withAnalytics(withOptimizely(routedOrderBy)));
